import ServerSideTable from './ServerSideTable/ServerSideTable';

export default ServerSideTable;
